import { compareId } from './comparators';

import type { Notification, NotificationGroup } from 'pl-api';

/** Notification types known to Nicolium. */
const NOTIFICATION_TYPES = [
  'follow',
  'follow_request',
  'mention',
  'reblog',
  'favourite',
  'poll',
  'status',
  'move',
  'chat_mention',
  'emoji_reaction',
  'reaction',
  'update',
  'event_reminder',
  'participation_request',
  'participation_accepted',
  'bite',
  'quote',
  'quoted_update',
  'subscribed_reaction',
] as const;

/** Notification types to exclude from the "All" filter by default. */
const EXCLUDE_TYPES = ['chat_mention', 'admin.report'] as const;

type NotificationType = Notification['type'];

const countUnreadNotifications = (
  notifications: Pick<NotificationGroup, 'most_recent_notification_id'>[],
  lastReadId?: string | null,
) => {
  if (!lastReadId) return notifications.length;

  return notifications.reduce((count, notification) => {
    if (compareId(notification.most_recent_notification_id, lastReadId) > 0) {
      return count + 1;
    }

    return count;
  }, 0);
};

export { countUnreadNotifications, NOTIFICATION_TYPES, EXCLUDE_TYPES, type NotificationType };
